const getUrl = (to: string): URL | null => {
  try {
    const base = globalThis.location?.origin ?? 'http://localhost';
    return new URL(to, base);
  } catch {
    return null;
  }
};

export const isThreadNotificationLink = (to?: string): boolean => {
  if (!to) return false;
  return getUrl(to)?.searchParams.has('thread') ?? false;
};

export const notificationLinkTargetsThread = (
  to: string | undefined,
  threadId: string | undefined | null
): boolean => {
  if (!to || !threadId) return false;
  return getUrl(to)?.searchParams.get('thread') === threadId;
};
